import PatientDocuments from '@/components/PatientDocuments/PatientDocuments';

interface IPDAttachmentsTabProps {
  admissionId: string;
  patientId: string;
}

export default function IPDAttachmentsTab({ admissionId, patientId }: IPDAttachmentsTabProps) {
  return <PatientDocuments patientId={patientId} link={{ admissionId }} />;
}
